import IconType from "@/types/Icon.type";
import IconCar from "@Icons/ticket/addons/IconCar"
import IconMotorcycle from "@Icons/ticket/addons/IconMotorcycle"
import IconBicycle from "@Icons/ticket/addons/IconBicycle"

interface IconAddonProps extends IconType {
    title: "IconCar" | "IconMotorcycle" | "IconBicycle";
}

function IconAddon(props: IconAddonProps) {
    const {
        title,
    } = props

    const matchedAddons = {
        IconCar,
        IconMotorcycle,
        IconBicycle,
    }

    const AddonIcon = matchedAddons[title]

    if (AddonIcon) {
        return <AddonIcon {...props}/>
    }

    return null
}

export default IconAddon